// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Phpy","colBig":"styles_colBig__2Gnur","colSmall":"styles_colSmall__3OQ55","shopifyNameWrapper":"styles_shopifyNameWrapper__Kzuq4"};